import { toPng } from "html-to-image";

export async function snapshotElement(el: HTMLElement, filename: string) {
  try {
    const dataUrl = await toPng(el, {
      pixelRatio: 2,
      backgroundColor: "#F2EEE6",
      cacheBust: true,
      filter: (node) => {
        // não capturar a Toolbar (sticky bar)
        if (node instanceof HTMLElement && node.dataset.snapshotIgnore === "true") return false;
        return true;
      }
    });
    const a = document.createElement("a");
    a.href = dataUrl;
    a.download = filename;
    a.click();
  } catch (e) {
    console.error(e);
    alert("Falhou ao gerar PNG: " + (e as Error).message);
  }
}
